import utils from '../../../common/util'
import cmpSelectChoices from '../../cmp-select-choices'
import { getFundDetails } from './fundDetails'

export const listContainer = (fundList, language) => {
	const fundContainer = document.querySelector('.list')

	fundList.forEach(async (fund) => {
		// Leverage a targeted DIV to ensure fund order
		const targetId = 'fund-list-detail-container-' + fund.id
		const targetDiv = document.createElement('div')
		targetDiv.setAttribute('id', targetId)
		fundContainer.appendChild(targetDiv)

		const newDiv = document.createElement('div')
		let fundDetails = null
		let classid = (fund.classes && fund.classes.length > 0) ? fund.classes[0].value : null
		if (fund.fundDetailItem == null) {
			let searchParams =  ""
			if (window.location.search) {
				searchParams = new URLSearchParams(window.location.search)
			}
			if (searchParams && searchParams.get('fundIdSelected' + fund.id)) {
				classid = searchParams.get('classIdForFund' + fund.id)
			}
			fundDetails = await getFundDetails(fund.id, classid, language, null)
		}
		else
		{
			fundDetails = await getFundDetails(fund.id, classid, language, fund.fundDetailItem)
		}

		newDiv.innerHTML = fundTemplate(fund, fundDetails)

		if (!classid) {
			// hide share class dropdown when there are no share classes.
			newDiv.querySelector('.cmp-fund-list__fund-container__class-dropdown').classList.add('d-none')
		}
		handleOnClickEntries(fundDetails, newDiv) // all card clickeable
		initChoices(newDiv, fund.id, language, fundDetails) // fund class dropdown handler
		if (fundDetails.moreLabel && (fundDetails.managers || fundDetails.objective)) {
			handleMoreButton(newDiv)
		}

		document.getElementById(targetId).appendChild(newDiv)
	})
}

const fundTemplate = (fund, fundDetails) => {
	let disclaimerHtml = ''
	if (fund.disclaimer) {
		disclaimerHtml = `
      <div class="row w-100 m-0"> 
        <div class="col-12">
          <div class="cmp-fund-list__fund-container__disclaimer">
            ${fund.disclaimer}
          </div>
        </div>
      </div>
    `
	}

	const showQuickLinks = !fundDetails.quickLinks ? 'd-none' : ''
	const searchPlaceholder = fund.classes.length > 10 ? `search-placeholder="${fund.shareclassSearchPlaceholderLabel ?? 'Search share classes'}"` : ''
	let fundDetailPageUrl = '';
	if (fundDetails && fundDetails.fundDetailPage && fundDetails.fundDetailPage.url) {
		fundDetailPageUrl = fundDetails.fundDetailPage.url;
	}

	let fundContainer = `
    <div class="cmp-fund-list__fund-container row m-0 mb-6">
        <div class="col-sm-8">
            <a href="${fundDetailPageUrl}" class="cmp-fund-list__fund-container__title" data-isin="${fundDetails.isin}">
                ${fund.name}
            </a>
        </div>
        <div class="col-sm-4 mt-2 mt-sm-0">
            <div class="cmp-fund-list__fund-container__class-dropdown">
                <select data-component="cmpSelectChoices" ${searchPlaceholder}>
                    ${options(fund.classes)}
                </select>
            </div>
        </div>
        ${disclaimerHtml}
        <div class="row w-100 m-0"> 
            <div class="col-sm-8">
                <div class="col">
                    <div class="cmp-fund-list__fund-container__fund-entries row flex-nowrap flex-sm-wrap overflow-auto">
                        ${fundDetails.entries}
                    </div>
                </div>
            </div>
            <div class="col-sm-4 cmp-fund-list__fund-container__quick-links">
                <div class="cmp-fund-list__fund-container__quick-links__title ${showQuickLinks}">
                    ${fundDetails.quickLinksLabel}
                </div>
                <div class="cmp-fund-list__fund-container__quick-links__ctas ${showQuickLinks}">
                    ${fundDetails.quickLinks}
                </div>`
	if (fundDetails.moreLabel && (fundDetails.managers || fundDetails.objective)) {
		fundContainer +=
			`<div class="cmp-fund-list__fund-container__quick-links__more-btn">
                    <button data-text-more="${fundDetails.moreLabel}" data-text-less="${fundDetails.lessLabel}"></button>
                </div>`
	}
	fundContainer +=
		`</div>`
	if (fundDetails.managers || fundDetails.objective) {
		fundContainer +=
			`<div class="col cmp-fund-list__fund-container__more-info">
								<hr>
								<div class="row">`
		if (fundDetails.managers) {
			fundContainer +=
				`<div class="col-sm-3 cmp-fund-list__fund-container__more-info__managers">
												<span>${fundDetails.managersLabel}</span>
												<div class="cmp-fund-list__fund-container__more-info__managers__names">
														${fundDetails.managers}
												</div>
										</div>`
		}
		if (fundDetails.objective) {
			fundContainer +=
				`<div class="col-sm-9 cmp-fund-list__fund-container__more-info__objective">
												<span>${fundDetails.objective ? fundDetails.objectiveLabel : ''}</span>
												<div class="cmp-fund-list__fund-container__more-info__objective__text">
														${fundDetails.objective ? fundDetails.objective : ''}
												</div>`
		}
		fundContainer +=
			`</div>`
	}
	fundContainer +=
		`</div>
							</div>
					</div>
			</div>
			`
	return fundContainer
}

const options = (classes) => {
	if (classes) {
		let options = ''
		classes.forEach((fundClass) => {
			const isDefault = fundClass.isdefault ? 'selected' : ''
			const option = `<option value=${fundClass.value} ${isDefault}>${fundClass.name}</option>`
			options += option
		})

		return options
	}
}

function initChoices(newDiv, fundId, language, fundDetailItem) {
	const choices = newDiv.querySelector('[data-component*="cmpSelectChoices"]')

	choices.addEventListener('change', async (event) => {
		const fundClassId = event.target.value
		//console.log(fundClassId);
		utils.isLoading(true)
		let fundDetails = null
		if(fundDetailItem == undefined || fundDetailItem == null){
			fundDetails = await getFundDetails(fundId, fundClassId, language, null)
		}
		else
		{
			fundDetails = fundDetailItem
			fundDetailItem = null
		}
		//console.log(fundDetails)
		newDiv.querySelector(
			'.cmp-fund-list__fund-container__fund-entries'
		).innerHTML = fundDetails.entries

		let quickLinks = newDiv.querySelector(
			'.cmp-fund-list__fund-container__quick-links__ctas'
		)
		if (quickLinks) {
			quickLinks.innerHTML = fundDetails.quickLinks
		}

		let managers = newDiv.querySelector(
			'.cmp-fund-list__fund-container__more-info__managers__names'
		)
		if (managers) {
			managers.innerHTML = fundDetails.managers
		}

		let objectiveDiv = newDiv.querySelector(
			'.cmp-fund-list__fund-container__more-info__objective__text'
		)
		if (objectiveDiv) {
			objectiveDiv.innerHTML = fundDetails.objective
		}

		const link = newDiv.querySelector('.cmp-fund-list__fund-container__title')
		link.dataset.isin = fundDetails.isin

		let searchParams

		if (window.location.search) {
			searchParams = new URLSearchParams(window.location.search)
			searchParams.set('classIdForFund' + fundId, fundClassId)
			searchParams.set('fundIdSelected' + fundId, fundId)
		}

		const url = window.location.origin + window.location.pathname + '?' + searchParams.toString()
		window.history.replaceState({}, document.title, url)
		utils.isLoading(false)
	})

	let searchParams
	if (window.location.search) {
		searchParams = new URLSearchParams(window.location.search)
	}

	if (searchParams && searchParams.get('fundIdSelected' + fundId)) {
		const fundClassSelector = cmpSelectChoices.init(choices)
		fundClassSelector.setChoiceByValue(searchParams.get('classIdForFund' + fundId))
	} else {
		cmpSelectChoices.init(choices)
		choices.dispatchEvent(new Event('change'))

	}
}

function handleOnClickEntries(fundDetails, newDiv) {
	newDiv
		.querySelector('.cmp-fund-list__fund-container__fund-entries')
		.addEventListener(
			'click',
			function (event) {
				let link = newDiv.querySelector('.cmp-fund-list__fund-container__title')
				let isin = link.dataset.isin

				let url = fundDetails.fundDetailPage.url
				if (isin) {
					url = fundDetails.fundDetailPage.url + '?isin=' + isin
				}
				window.location.href = url
			},
			false
		)
}

function handleMoreButton(newDiv) {
	const button = newDiv.querySelector(
		'.cmp-fund-list__fund-container__quick-links__more-btn button'
	)

	const textMore = button.getAttribute('data-text-more')

	button.innerHTML = textMore

	button.addEventListener('click', (event) => {
		const btnClicked = event.target
		btnClicked.classList.toggle('active')

		const textMore = btnClicked.getAttribute('data-text-more')
		const textLess = btnClicked.getAttribute('data-text-less')

		if (!btnClicked.classList.contains('active')) {
			btnClicked.innerHTML = textMore
		} else {
			btnClicked.innerHTML = textLess
		}

		newDiv
			.querySelector('.cmp-fund-list__fund-container__more-info')
			.classList.toggle('active')
	})
}
